<script setup>
import { computed } from 'vue';
import BaseSettingsHeader from '../components/BaseSettingsHeader.vue';
import SettingsLayout from '../SettingsLayout.vue';
import SamlSettings from './components/SamlSettings.vue';
import ScimSettings from './components/ScimSettings.vue';

import { usePolicy } from 'dashboard/composables/usePolicy';
import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const { shouldShow } = usePolicy();

const allowedLoginMethods = computed(
  () => window.rookooConfig.allowedLoginMethods || ['email']
);

const isSamlSsoEnabled = computed(() =>
  allowedLoginMethods.value.includes('saml')
);

const installationTypes = [
  INSTALLATION_TYPES.CLOUD,
  INSTALLATION_TYPES.ENTERPRISE,
  INSTALLATION_TYPES.COMMUNITY,
];

const shouldShowSaml = computed(() => {
  const hasPermission = shouldShow(
    FEATURE_FLAGS.SAML,
    ['administrator'],
    installationTypes
  );
  return hasPermission && isSamlSsoEnabled.value;
});

const shouldShowScim = computed(() =>
  shouldShow(FEATURE_FLAGS.SCIM, ['administrator'], installationTypes)
);
</script>

<template>
  <SettingsLayout
    class="max-w-2xl mx-auto"
    :loading-message="$t('ATTRIBUTES_MGMT.LOADING')"
  >
    <template #header>
      <BaseSettingsHeader
        :title="$t('SECURITY_SETTINGS.TITLE')"
        :description="$t('SECURITY_SETTINGS.DESCRIPTION')"
        :link-text="$t('SECURITY_SETTINGS.LINK_TEXT')"
        feature-name="saml"
      />
    </template>
    <template #body>
      <SamlSettings v-if="shouldShowSaml" />
      <div v-else class="mt-6 text-sm text-slate-600">
        {{ $t('SECURITY_SETTINGS.SAML_DISABLED_MESSAGE') }}
      </div>

      <ScimSettings v-if="shouldShowScim" />
    </template>
  </SettingsLayout>
</template>
